<div id="detail-content" nz-row>

  <div nz-col nzSpan="1"></div>

  <div nz-col nzSpan="6">
    <app-protein-detail></app-protein-detail>
  </div>
  
  <div nz-col nzSpan="1"></div>

  <div nz-col nzSpan="15">
    <app-graph-visual [detailDownload]="true"></app-graph-visual>
  </div>

  <div nz-col nzSpan="1"></div>

</div>
